export function dateFormatter(date) {
    function pad(num) {
        num = num + '';
        return num.length < 2 ? '0' + num : num;
    }
    return date.getFullYear() + '-' + pad(date.getMonth()+1) + '-' + pad(date.getDate());
  }



// WEBPACK FOOTER //
// ./src/utils/formatter/date.js